import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { IconButton, Grid, Card, Tooltip } from "@material-ui/core";
import { getLocalizedString } from "@icarius-localization/strings";
import { DeleteIcon } from "@icarius-icons";
import Form from "./form";
import { deleteHealthDefinitionAction } from "../../actions";
import DataContainer from "@icarius-common/abmComponents/dataContainer";
import { openDialogAction } from "@icarius-common/dialog/actions";
import useIsSocietyCountry from "@icarius-app/components/wrapper/hooks/useIsSocietyCountry";

const DataItem = (props) => {
    const { data, color, closeNew } = props;

    const dispatch = useDispatch();

    const isCreate = !Boolean(data);

    const [isOpen, setIsOpen] = useState(isCreate); //si viene sin data, que este abierto por defecto
    const isChile = useIsSocietyCountry("CL");

    const handleDeletePublication = () => {
        if (isCreate) {
            closeNew();
        } else {
            dispatch(deleteHealthDefinitionAction(data));
        }
    };

    const handleClosePublication = () => {
        Boolean(data) && setIsOpen((prev) => !prev);
    };

    // En la card de alta este boton no borra nada: handleDeletePublication cae en
    // closeNew() y descarta lo tipeado sin crear. El dialogo igual decia "borrar",
    // que es enganoso, asi que en alta se confirma como cancelacion.
    const handleOpenDeleteDialog = () => {
        dispatch(
            openDialogAction({
                title: isCreate ? getLocalizedString("cancel") : getLocalizedString("deleteHealthInstitution"),
                msg: isCreate
                    ? getLocalizedString("unsavedChangesConfirmation")
                    : getLocalizedString("doYouWantToDeleteHealthInstitution"),
                onConfirm: handleDeletePublication,
            })
        );
    };

    return (
        <>
            <Card
                style={{
                    width: "100%",
                    borderRadius: 10,
                    background: isOpen || isCreate ? color : "",
                    color: (isOpen || isCreate) && "white",
                }}
            >
                <Grid container item xs={12} direction="row" style={{ padding: "10px 20px" }}>
                    <Grid
                        container
                        item
                        xs={11}
                        style={{ cursor: Boolean(data) ? "pointer" : "" }}
                        onClick={handleClosePublication}
                    >
                        {isCreate ? (
                            <DataContainer
                                lg={12}
                                sm={12}
                                md={12}
                                text={getLocalizedString("createHealthInstitution")}
                            />
                        ) : (
                            <>
                                <DataContainer xs={12} sm={6} md={2} lg={2} text={data.code} />
                                <DataContainer xs={12} sm={6} md={4} lg={4} text={data.name} />
                                {isChile && (
                                    <DataContainer
                                        xs={12}
                                        sm={6}
                                        md={3}
                                        lg={3}
                                        text={`Previred: ${data.previredCode}`}
                                    />
                                )}
                                {isChile && (
                                    <DataContainer xs={12} sm={6} md={3} lg={3} text={`LRE: ${data.lreCode || "-"}`} />
                                )}
                            </>
                        )}
                    </Grid>
                    <Grid container direction="row" item xs={1} justify="center">
                        <Tooltip title={getLocalizedString("delete")}>
                            <IconButton size={"small"} disableRipple onClick={handleOpenDeleteDialog}>
                                <DeleteIcon style={{ fill: "var(--mainText)" }} fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    </Grid>
                </Grid>
            </Card>
            {isOpen && <Form data={data} handleClose={isCreate ? closeNew : handleClosePublication} />}
        </>
    );
};

export default DataItem;
